/** Lightweight toast host — one message at a time, which is all this app needs. */
import { useCallback, useMemo, useRef, useState } from "react";
import type { ReactNode } from "react";
import { ToastContext, type ToastKind } from "../hooks/useToast";

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toast, setToast] = useState<{ message: string; kind: ToastKind } | null>(null);
  const timerRef = useRef<number | null>(null);

  const show = useCallback((message: string, kind: ToastKind = "info") => {
    if (timerRef.current) window.clearTimeout(timerRef.current);
    setToast({ message, kind });
    timerRef.current = window.setTimeout(() => setToast(null), 4200);
  }, []);

  const value = useMemo(() => ({ show }), [show]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      {toast && (
        <div className={`toast toast-${toast.kind}`} role="status" aria-live="polite">
          {toast.message}
        </div>
      )}
    </ToastContext.Provider>
  );
}
